const flightState = Symbol('state') as InjectionKey<string>
const flightMethods = Symbol('methods') as InjectionKey<string>

export default {
  flightState,
  flightMethods,
}
